import FinancialsTables from 'pages/Financials/components/financials-tables/FinancialsTables';

export default FinancialsTables;
